import axios, { AxiosInstance } from 'axios';
import { Endpoints } from '../endpoints';

export interface LoginRequest {
  username: string;
  password: string;
}
export interface UserSession {
  idToken: string;
  refreshToken: string;
  accessToken: string;
}

/**
 * Makes a request to the server to log in a user with the provided credentials.
 *
 * @param {LoginRequest} data - The user's login credentials.
 * @param {AxiosInstance} [instance=axios] - The Axios instance to use for the request.
 * @return {Promise<UserSession>} A promise that resolves with the user's session data.
 */
export const login = async (data: LoginRequest, instance: AxiosInstance = axios) => {
  return instance.post<UserSession>(Endpoints.Authentication.LOGIN, data);
};

export interface SignUpRequest {
  firstName: string;
  lastName: string;
  email: string;
  participantKey: string;
  username: string;
  password: string;
}

export interface SignUpResponse {}

export const signUp = async (data: SignUpRequest, instance: AxiosInstance = axios) => {
  return instance.post<SignUpResponse>(Endpoints.Authentication.SIGN_UP, data);
};

export interface RefreshRequest {
  refreshToken: string;
}

export const refresh = async (data: RefreshRequest, instance: AxiosInstance = axios) => {
  return instance.post<UserSession>(Endpoints.Authentication.REFRESH, data);
};

export interface ForgotPasswordRequest {
  username: string;
}

export interface ForgotPasswordResponse {}

export const forgotPassword = async (
  data: ForgotPasswordRequest,
  instance: AxiosInstance = axios,
) => {
  return instance.post<ForgotPasswordResponse>(Endpoints.Authentication.FORGOT_PASSWORD, data);
};

export interface VerifySignUpRequest {
  code: string;
  username: string;
}

export interface VerifySignUpResponse {}

export const verifySignup = async (data: VerifySignUpRequest, instance: AxiosInstance = axios) => {
  return instance.post<VerifySignUpResponse>(Endpoints.Authentication.VERIFY_SIGN_UP, data);
};

export interface ConfirmForgotPasswordResponse {}
export interface ConfirmForgotPasswordRequest {
  ConfirmationCode: string;
  Username: string;
  Password: string;
  confirmPassword: string;
}

export const confirmPasswordReset = async (
  params: ConfirmForgotPasswordRequest,
  instance: AxiosInstance = axios,
) => {
  return instance.post(Endpoints.Authentication.CONFIRM_PASSWORD_CHANGE, params);
};
